import { Router, Route } from '../abstracts/Router';

export class WbDataLayers extends Router {
  init() {
    this.routes = [
      new Route('view_cart', ['/achat/panier', '/checkout/cart'], this.viewCart.bind(this)),
      new Route('begin_checkout', ['/achat/adresses', '/checkout/addresses'], this.beginCheckout.bind(this)),
      new Route('purchase', ['/achat/paiement', 'checkout/payment'], this.completeCheckout.bind(this)),
      new Route('view_item', ['^/(produit|product|billetterie|ticketing)/[a-z0-9-%]+'], this.viewProduct.bind(this)),
      new Route('purchase', ['/client/commande', '/customer/order'], this.completeCheckout.bind(this)),
    ];

    window.addEventListener('craft.commerce.add_to_cart', this.addToCart.bind(this));
  }

  viewProduct() {
    let element = document.querySelector('.wb-product [data-purchasable]');
    let category = 'Product';
    let event = 'view_item';
    if (!element) {
      element = document.querySelector('.wb-event [data-purchasable]');
      category = 'Event';
      event = 'view_event';
    }
    const item = JSON.parse(element.dataset.purchasable);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: event,
      ecommerce: {
        items: [
          {
            item_name: item.title,
            item_id: item.sku,
            price: item.price,
            category: category,
          },
        ],
      },
    });
  }

  addToCart(e) {
    console.log('test');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        items: e.detail,
      },
    });
  }

  async viewCart() {
    const cart = await this._getCart();

    const items = cart.lineItems.map(item => {
      let category = 'product';
      if (item.snapshot.eventId) {
        category = 'event';
      }
      return {
        item_name: item.description,
        item_id: item.sku,
        quantity: item.qty,
        price: item.salePrice,
        type: category,
      };
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_cart',
      ecommerce: {
        items: items,
      },
    });
  }

  async beginCheckout() {
    const cart = await this._getCart();
    let type = '';
    const items = cart.lineItems.map(item => {
      let category = 'product';
      if (item.snapshot.eventId) {
        category = 'event';
        type = '_event';
      }
      return {
        item_name: item.description,
        item_id: item.sku,
        quantity: item.qty,
        quantity: item.type,
        price: item.salePrice,
        category: category,
      };
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'begin_checkout' + type,
      ecommerce: {
        items: items,
      },
    });
  }

  async completeCheckout() {
    const params = new URLSearchParams(window.location.href);
    const isPurchase = Boolean(params.get('success'));

    if (isPurchase) {
      const order = JSON.parse(document.querySelector('[data-purchase]')?.dataset.purchase);
      window.dataLayer = window.dataLayer || [];
      let type = '';
      let itemsMap = order.items.map(item => {
        let category = 'product';
        if (item.type == 'event') {
          category = 'event';
          type = '_event';
        }
        return {
          item_name: item.title,
          item_id: item.sku,
          price: item.price,
          quantity: item.qty,
          category: category,
        };
      });

      window.dataLayer.push({
        event: 'purchase' + type,
        ecommerce: {
          transaction_id: order.transaction_id,
          affiliation: order.affiliation,
          value: order.price,
          tax: order.tax,
          shipping: order.shipping,
          items: itemsMap,
        },
      });

      //window.location.href = window.location.href.replace('&purchase=true', '');
    }
  }

  async _getCart() {
    const response = await fetch('/actions/commerce/cart/get-cart', {
      headers: {
        Accept: 'application/json',
      },
    });

    return (await response.json()).cart;
  }
}
